import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import Constants from '../../common/constants';
import layoutAction from '../../actions/layout';
import authAction from '../../actions/auth';
import MText from '../../components/Common/MText';
import MButton from '../../components/MButton';
import Colours from '../../styles/colours';

const Logout = (props) => {
  const [redirect, setRedirect] = useState(false);

  const onLogoutClicked = async () => {
    props.dispatchLogout();
    props.dispatchLogoutModalToggle();

    // setRedirect(true);
  };

  const onCancelClicked = async () => {
    props.dispatchLogoutModalToggle();
  };

  return (
    <>
      {
        redirect && <Redirect to={Constants.Url.Login} />
      }
      {
        props.showLogout && (
          <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 9999, backgroundColor: '#00000088' }}>
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header">
                  <MText text="Confirm logout?" size={15} medium />
                </div>
                <div className="modal-footer">
                  <MButton text="Logout" className="px-4 mr-4" colour={Colours.Gray3} textColour={Colours.Black} onClick={() => onLogoutClicked()} />
                  <MButton text="Cancel" className="px-4" colour={Colours.Primary} textColour={Colours.White} onClick={() => onCancelClicked()} />
                </div>
              </div>
            </div>
          </div>
        )
      }
    </>
  );
};

Logout.propTypes = {
  dispatchLogout:            PropTypes.func.isRequired,
  dispatchLogoutModalToggle: PropTypes.func.isRequired,
  showLogout:                PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => ({
  showLogout: state.layout.showLogout,
});

const mapDispatchToProps = (dispatch) => ({
  dispatchLogoutModalToggle: () => layoutAction.logoutModalToggle(dispatch),
  dispatchLogout:            () => authAction.logout(dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(Logout);
